import getCompatibleWeakMap from 'src/internal/shared/apollo/getCompatibleWeakMap';

import type {InMemoryCache} from '@apollo/client';

const CompatibleMap = getCompatibleWeakMap();

let sharedApolloCaches: WeakMap<symbol, InMemoryCache> | null = null;

export function getApolloSharedCaches(): WeakMap<symbol, InMemoryCache> {
  if (sharedApolloCaches) {
    return sharedApolloCaches;
  }

  sharedApolloCaches = new CompatibleMap<symbol, InMemoryCache>();
  return sharedApolloCaches;
}
